<template>
  <v-expansion-panels
    light
    accordion
    v-model="panel"
  >
    <v-expansion-panel>
      <v-expansion-panel-header style="text-align: center">
        <b :style="{ color: balanceLeft.length === 0  ? 'green' : 'red' }">
            {{balanceLeft.length === 0  ? 'BALANCED' : 'OUT OF BALANCE'}}</b>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-row dense>
          <v-col cols="1" class="text-left">
            <b>BANKS</b>
          </v-col>
          <v-col cols="2">
            <v-text-field
              dense
              label="OD"
              readonly
              :value="amountFormat(totalBalanceByDailySections.banks.OD)"
            ></v-text-field>
          </v-col>
          <v-col cols="2">
            <v-text-field
              dense
              label="Deposits"
              readonly
              :value="amountFormat(totalBalanceByDailySections.banks.deposits)"
            ></v-text-field>
          </v-col>
          <v-col cols="2">
            <v-text-field
              dense
              label="Checks"
              readonly
              :value="amountFormat(totalBalanceByDailySections.banks.checks)"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row
          dense
          class="d-flex align-end"
        >
          <v-col cols="1" class="text-left" align-self="center">
            <b>FUNDS</b>
          </v-col>
          <v-col cols="2">
            <v-text-field
              dense
              label="OD"
              readonly
              :value="amountFormat(totalBalanceByDailySections.funds.OD)"
            ></v-text-field>
          </v-col>
          <v-col cols="2">
            <v-text-field
              dense
              label="Collections"
              readonly
              :value="amountFormat(totalBalanceByDailySections.funds.collections)"
            ></v-text-field>
          </v-col>
          <v-col cols="2">
            <v-text-field
              dense
              label="Warrants"
              readonly
              :value="amountFormat(totalBalanceByDailySections.funds.warrants)"
            ></v-text-field>
          </v-col>
          <v-col cols="5">
            <v-textarea
              label="Balance"
              readonly
              dense
              rows="3"
              :value="balanceLeft"
              class="gl-expandable-component-text-area"
            >
            </v-textarea>
          </v-col>
        </v-row>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import {
  mapState,
  mapGetters,
} from 'vuex';
import { calcTotalBalanceByDailySections, getRemainingBalance } from './gl-balances.util';
import { amountFormat } from '../../../util/shared/vue-global';

export default {
  data: () => ({
    panel: -1,
  }),
  props: {
    baseCrudKey: {
      type: String,
      default: 'GLExpandable',
    },
  },
  created() {
  },
  computed: {
    ...mapGetters('base/crud', ['criteria', 'item', 'items']),
    ...mapState({
      storeTotalBalance: (state) => state.glDaily.glDailyTransaction.totalBalance,
    }),
    totalBalanceByDailySections() {
      // console.info('--storeTotalBalance---', this.storeTotalBalance);
      const calculatedBalance = calcTotalBalanceByDailySections(this.storeTotalBalance);
      // console.info('--calculatedBalance---', calculatedBalance);
      return calculatedBalance;
    },
    balanceLeft() {
      const { funds, banks } = this.totalBalanceByDailySections;
      const remainingBalances = getRemainingBalance(funds, banks);
      const remainingBalancesArray = remainingBalances.map((item) => {
        const itemString = item.replace(/\n/g, ',');
        return itemString;
      });
      const remainingBalancesString = remainingBalancesArray.join('\n');
      return remainingBalancesString;
    },
  },
  methods: {
    amountFormat,
  },
};
/*
  adding red color to text in text-area
  https://stackoverflow.com/questions/60350608/change-color-in-v-textarea-in-vuetify
*/
</script>

<style>
   .gl-expandable-component-text-area textarea { color: red !important }
</style>
